// characters
import placeholderImage from "./characters/Placeholder 150.jpg";
//import friedrichImage from "./characters/Friedrich 150.jpg";
import kahiraImage from "./characters/Kahira 150.jpg";
import kristinaImage from "./characters/Kristina 150.jpg";
import morganaImage from "./characters/Morgana 150.jpg";
import narkisaImage from "./characters/Narkisa 150.jpg";

export const characterAssets = {
  _placeholder: {
    path: placeholderImage,
    alt: "The Last Spark by Eleonor Piteira @eleonorpiteira",
  },
  friedrich: {
    path: placeholderImage,
    alt: "The Last Spark by Eleonor Piteira @eleonorpiteira",
  },
  kahira: {
    path: kahiraImage,
    alt: "",
  },
  kristina: {
    path: kristinaImage,
    alt: "",
  },
  morgana: {
    path: morganaImage,
    alt: "",
  },
  narkisa: {
    path: narkisaImage,
    alt: "",
  },
};
